import React from 'react';
import { cn } from '../../lib/utils';

export function AuroraText({ children, className }) {
  return (
    <span
      className={cn(
        'relative inline-block bg-gradient-to-r from-amber-700 via-amber-600 to-amber-800 dark:from-amber-400 dark:via-yellow-300 dark:to-amber-500 bg-clip-text text-transparent animate-gradient bg-[length:200%_auto] font-extrabold',
        className
      )}
    >
      {children}
    </span>
  );
}
